






















































































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import creditServices from '@/services/credit-services';
import commonService from '@/services/common-services';
import { eventBus } from '@/main';
const numeral = require('numeral');

interface RechargeMethod {
  ID: number;
  value: number;
  name: string;
  ownerName: string;
  bankNumber: string;
  branchName: string;
  image: string;
  bankCode: string;
  sortOrder?: number;
  isActive?: number;
}

@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  private rechargeMethods = [] as RechargeMethod[];
  private bankSelected: RechargeMethod | null = null;
  private isLoading = false;
  private requested = false;
  private amountRequested = 0;
  private rechargeModel: any = {
    rechargeValue: '0',
    bankId: 0,
    tradeContent: ''
  };

  private readonly rechargeHistoryHandler = (item: any) => {
    this.amountRequested = item.amount;
    this.requested = true;
  };

  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo || {};
  }

  get qrLink() {
      const amount = this.requested ? this.amountRequested : (numeral(this.rechargeModel.rechargeValue).value() || 0);
      if (!this.bankSelected) {
        return '';
      }
      return `https://api.vietqr.io/image/${this.bankSelected.bankCode}-${this.bankSelected.bankNumber}-X1lAHCn.jpg?addInfo=${this.userInfo.userCode || ''} chuyen khoan&accountName=${encodeURIComponent(this.bankSelected.ownerName)}&amount=${amount}`;
  }

  private async created() {
    await this.loadBankInfo();
    eventBus.$on(APP_CONFIG.eventBusAction.selectRechargeHistory, this.rechargeHistoryHandler);
  }

  private beforeDestroy() {
    eventBus.$off(APP_CONFIG.eventBusAction.selectRechargeHistory, this.rechargeHistoryHandler);
  }

  private normalizeBank(bank: any): RechargeMethod {
    const id = Number(bank.value || bank.ID || 0);
    const sortOrder = bank.sortOrder !== undefined && bank.sortOrder !== null
      ? Number(bank.sortOrder)
      : (bank.SortOrder !== undefined && bank.SortOrder !== null ? Number(bank.SortOrder) : id);
    const isActive = bank.isActive !== undefined && bank.isActive !== null
      ? Number(bank.isActive)
      : (bank.IsActive !== undefined && bank.IsActive !== null ? Number(bank.IsActive) : 1);
    return {
      ID: id,
      value: id,
      name: bank.name || bank.BankName || '',
      ownerName: bank.ownerName || bank.Owner || '',
      bankNumber: bank.bankNumber || bank.CardNumber || '',
      branchName: bank.branchName || bank.Branch || '',
      image: bank.image || bank.Image || '',
      bankCode: bank.bankCode || bank.BankCode || bank.name || bank.BankName || '',
      sortOrder,
      isActive
    };
  }

  private setDefaultBank() {
    const activeBanks = this.rechargeMethods.filter(x => Number(x.isActive) !== 0);
    const defaultBank = activeBanks[0] || this.rechargeMethods[0] || null;
    this.bankSelected = defaultBank;
    this.rechargeModel.bankId = defaultBank ? defaultBank.value : 0;
  }

  private async loadBankInfo() {
    try {
      this.isLoading = true;
      const result = await commonService.getBankInfo();
      const list = (((result || {}).data || {}).data || []) as any[];
      this.rechargeMethods = list
        .map(item => this.normalizeBank(item))
        .filter(item => item.value > 0 && item.name && item.bankNumber)
        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      this.setDefaultBank();
    } catch {
      this.rechargeMethods = [];
      this.bankSelected = null;
      this.rechargeModel.bankId = 0;
    } finally {
      this.isLoading = false;
    }
  }

  private onSelectBank(bankId: number) {
    this.bankSelected = this.rechargeMethods.find(x => x.value === bankId) || null;
    this.rechargeModel.bankId = bankId;
  }

  private setDepositPreset(amount: number) {
    this.rechargeModel.rechargeValue = amount.toLocaleString('en-US');
    this.requested = false;
  }

  private copyToClipboard(text: string, label: string) {
    if (!text) { return; }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    Vue.notify({
      group: 'foo',
      type: 'success',
      title: 'Đã sao chép!',
      text: `Đã sao chép ${label}: ${text}`
    });
  }
  
  private async recharge() {
    try {
      if (!this.rechargeModel.bankId || !this.bankSelected) {
        Vue.notify({
          group: 'foo',
          type: 'error',
          title: 'Thông báo!',
          text: 'Hiện chưa có tài khoản ngân hàng nạp tiền khả dụng.',
        });
        return false;
      }

      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {
        this.isLoading = true;

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId,
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: this.rechargeModel.tradeContent || `Chuyển tiền nạp ví ${this.userInfo.userCode || ''}`
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          this.amountRequested = numeral(this.rechargeModel.rechargeValue).value();
          this.rechargeModel = {
            rechargeValue: '0',
            bankId: this.bankSelected ? this.bankSelected.value : 0,
            tradeContent: ''
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
          this.requested = true;
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: `Tạo lệnh nạp tiền thất bại! ${result.data.error}`,
          });
        }
        this.isLoading = false;
      }
    } catch {
      this.isLoading = false;
      return false;
    }
  }
}
